import { type SlideDescriptor, type SelectorState } from "./state";

export function getSlideProperties(slide: SlideDescriptor) {
  return {
    slideID: slide.id,
    slideIsOptional: slide.optional || false,
    slideType: slide.type,
    slideTitle: slide.title,
  };
}

export function getFormattedSlideValue(selectorState: SelectorState): string | string[] | null {
  switch (selectorState.type) {
    case "multi":
      return selectorState.value?.map((v) => v.value) || null;
    case "single":
      return selectorState.value?.value || null;
    case "date":
      return selectorState.value
        ? `${selectorState.value.year}-${String(selectorState.value.month).padStart(
            2,
            "0"
          )}-${String(selectorState.value.day).padStart(2, "0")}`
        : null;
    case "email":
      return selectorState.value || null;
    case "short-text":
      return selectorState.value || null;
    case "slider":
      return selectorState.value?.value || null;
    case "location":
      return selectorState.value?.formattedText || null;
    case "time":
      if (!selectorState.value) {
        return null;
      }
      return (
        selectorState.value.quickPeriod ||
        `${selectorState.value.hour}:${selectorState.value.minute} ${selectorState.value.meridiem}`
      );
    default:
      return null;
  }
}
